import { useContext } from 'react';

import { NbaDataContext } from '../NbaDataProvider';
import { NbaDataType } from '../types';

export const useNbaData = (): NbaDataType | undefined => {
  return useContext(NbaDataContext);
};
